import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { ContactMessages } from '../../i18n/index';
import { ContactMeScreens as Screens } from '../../state/index';
import { LocationShape } from '../../utils/index';
import {FormContainer} from '../Forms/index';

const localizer = momentLocalizer(moment);

const AppointmentCalendarForm = (props) => {
  const {
    bookAppointment,
    contactLead,
    selectedLocation,
    selectedTime,
    setTimeSlot,
    getTimeSlots,
    availableTimeSlots,
    onComplete,
    isProcessing,
    changeScreen,
  } = props;

  const [showErrors, setShowErrors] = useState(false);
  const [calendarView, setCalendarView] = useState('week');
  const handleResize = () =>
    setCalendarView(window.innerWidth <= 600 ? 'day' : 'week');

  useEffect(() => {
    queryTimeSlots(new Date());
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const formSubmitted = () => {
    if (!selectedTime) {
      setShowErrors(true);
    } else {
      const resourceIds = selectedTime.resourceExternalIds;
      const resourceId = resourceIds
        ? resourceIds[Math.floor(Math.random() * resourceIds.length)]
        : 0;

      const bookAppointmentCb = (bookingWasSuccessful) => {
        if (bookingWasSuccessful) {
          onComplete({ type: 'appointment' });
          changeScreen(Screens.APPT_SUCCESS);
        } else {
          changeScreen(Screens.APPT_FAIL);
        }
      };

      bookAppointment(
        {
          duration: selectedTime.length,
          locationId: selectedLocation.id,
          resourceId,
          time: selectedTime.time,
          client: {
            firstName: contactLead.firstName,
            lastName: contactLead.lastName,
            email: contactLead.email,
            phone: contactLead.phone,
          },
        },
        bookAppointmentCb
      );
    }
  };

  const updateTimeSlotSelection = (timeSlot) => {
    setShowErrors(false);
    setTimeSlot(timeSlot);
  };

  const queryTimeSlots = (date) => {
    const start = moment(date).startOf('week');
    const end = moment(date).endOf('week');
    getTimeSlots({
      locationId: selectedLocation.id,
      startDate: start.toISOString(),
      endDate: end.toISOString(),
    });
  };

  const minTime = new Date();
  const maxTime = new Date();
  minTime.setHours(8, 0, 0); //8:00am
  maxTime.setHours(20, 0, 0); //8:00pm

  const dayFormat = {
    weekday: 'long',
    month: 'long',
    year: 'numeric',
    day: 'numeric',
  };
  const timeFormat = { hour: 'numeric', minute: 'numeric' };

  const selectedLocationString =
    selectedLocation && selectedLocation.id ? (
      <div className="selectedLocationString">
        Selected Location:
        <span className="selectedLocationString__name">
          {selectedLocation.name}{' '}
        </span>
        <span className="selectedLocationString__address">
          {selectedLocation.address},{' '}
        </span>
        <span className="selectedLocationString__cityState">
          {selectedLocation.city}, {selectedLocation.state}{' '}
          {selectedLocation.postalCode}
        </span>
      </div>
    ) : null;

  const selectedTimeString =
    selectedTime && selectedTime.time ? (
      <div className="selectedTimeString">
        {' '}
        Selected Time:
        <span className="selectedTimeString__date">
          {selectedTime.start.toLocaleDateString('en-US', dayFormat)},{' '}
        </span>
        <span className="selectedTimeString__time">
          {selectedTime.start.toLocaleTimeString('en-US', timeFormat)}
        </span>
      </div>
    ) : null;

  const buttonMessage = isProcessing ? (
    <FormattedMessage {...ContactMessages.loading} />
  ) : (
    <FormattedMessage {...ContactMessages.confirmAppointment} />
  );

  const errorString = showErrors ? (
    <div className="contactMe__error">
      <FormattedMessage {...ContactMessages.appointmentTimeSelectError} />
    </div>
  ) : null;

  const loadingOverlay = isProcessing ? (
    <div className="contactMe__loadingOverlay" />
  ) : null;

  return (
    <FormContainer className="contactMe__form" onSubmit={formSubmitted}>
      <div className="form-body">
        {loadingOverlay}
        <h5 className="form-description">
          <FormattedMessage {...ContactMessages.appointmentTimeSelectMessage} />
        </h5>
        {selectedLocationString}
        {selectedTimeString}
        <Calendar
          localizer={localizer}
          selectable
          events={availableTimeSlots || []}
          view={calendarView}
          onView={(v) => setCalendarView(v)}
          views={['week', 'day']}
          defaultDate={new Date()}
          min={minTime}
          max={maxTime}
          onSelectEvent={(timeSelection) =>
            updateTimeSlotSelection(timeSelection)
          }
          onNavigate={(date) => queryTimeSlots(date)}
        />
        {errorString}
      </div>
      <div className="form-actions">
        <button
          type="submit"
          className="form-submitBtn"
          disabled={isProcessing || showErrors}
        >
          {buttonMessage}
        </button>
      </div>
    </FormContainer>
  );
};

AppointmentCalendarForm.propTypes = {
  bookAppointment: PropTypes.any,
  setTimeSlot: PropTypes.any,
  getTimeSlots: PropTypes.any,
  availableTimeSlots: PropTypes.any,
  onComplete: PropTypes.any,
  isProcessing: PropTypes.any,
  selectedLocation: LocationShape,
  selectedTime: PropTypes.object,
  contactLead: PropTypes.object,
  changeTimeSlot: PropTypes.func,
  changeScreen: PropTypes.func,
};

export default AppointmentCalendarForm;
